<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="visible"
    :title="rowInfo.id==''?'添加':'编辑'"
    :loading="loading"
    @close="closeForm"
    width="60%">
    <span class="formContent">
      <el-form ref="rowInfo" :model="rowInfo" :rules="rules" label-width="200px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="所属城市" prop="cityCode">
              <el-select v-if="rowInfo.id==''" v-model="rowInfo.cityCode" multiple clearable filterable placeholder="请选择所属城市">
                <el-option
                  v-for="item in cityOptions"
                  :key="item.codeItemId"
                  :label="item.codeName"
                  :value="item.codeItemId">
                </el-option>
              </el-select>
              <el-select v-else v-model="rowInfo.cityCode" clearable filterable placeholder="请选择所属城市">
                <el-option
                  v-for="item in cityOptions"
                  :key="item.codeItemId"
                  :label="item.codeName"
                  :value="item.codeItemId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属项目" prop="projectId">
               <select-text v-model="rowInfo.projectId" :multiple="false" code-set-id="" :options="projectOptions"  placeholder="所属项目"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否公海" prop="isHighSeas">
              <select-text v-model="rowInfo.isHighSeas" code-set-id="1006"  placeholder="是否公海"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="基础车费（元）" prop="basicFare">
             <el-input v-model="rowInfo.basicFare" placeholder="基础车费（元）"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
             <el-form-item label="标准时长（分钟）" prop="standardTime">
             <el-input v-model.number="rowInfo.standardTime" placeholder="标准时长（分钟）"/>
            </el-form-item>
          </el-col>
           <el-col :span="12">
            <el-form-item label="超时标准（元/小时）" prop="timeoutStandard">
             <el-input v-model="rowInfo.timeoutStandard" placeholder="超时标准（元/小时）"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="现实油价（元/L）" prop="realOilPrices">
             <el-input v-model="rowInfo.realOilPrices" placeholder="现实油价（元/L）"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="税率" prop="taxRate">
              <el-input v-model="rowInfo.taxRate" placeholder="税率"><template slot="append">%</template></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="油费标准-夏季（6.1~9.30）" prop="standardTimeXia">
             <el-input v-model="rowInfo.standardTimeXia" placeholder="油费标准-夏季（6.1~9.30）"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="油费标准-非夏季" prop="standardTimeNoxia">
             <el-input v-model="rowInfo.standardTimeNoxia" placeholder="油费标准-非夏季"/>
            </el-form-item>
          </el-col>
        </el-row>
         <el-row>
          <el-col :span="12">
            <el-form-item label="服务费率" prop="serviceRate">
              <el-input v-model="rowInfo.serviceRate" placeholder="服务费率"><template slot="append">%</template></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </span>
    <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="submitForm('rowInfo')">保存</el-button>
        <el-button size="mini"  @click="closeForm">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { updCostInfoSet,qryCostInfoSet } from  "@/api/order/orderinfo"
import SelectText from '@/components/SelectText/index.vue'
import { citys } from '@/const/city.js'
import {loadProjectList} from "@/api/project";
export default {
  components: {
    SelectText
  },
  data() {
    var checkInt = (rule, value, callback) => {
        try{
          value = parseInt(value);
        }catch(ex){
          callback(new Error('请输入数字值'));
        }
        if (!Number.isInteger(value)) {
          callback(new Error('请输入数字值'));
        } else {
          if (value <=0) {
            callback(new Error('请输入大于0的整数'));
          } else {
            callback();
          }
        }
    };
    return {
      visible: false,
      formName: '新增',
      loading: false,
      projectOptions:[],
      rowInfo:{
        id:'',
        basicFare:'',
        standardTime:'',
        timeoutStandard:'',
        realOilPrices:'',
        standardTimeXia:'',
        standardTimeNoxia:'',
        taxRate:13,
        serviceRate:10,
        cityCode:'',
        cityName: '',
        projectId:'',
        isHighSeas:''
      },
      rules: {
        cityCode: [{ required: true, message: '请选择所属城市', trigger: 'change' }],
        isHighSeas: [{ required: true, message: '必填:是否公海', trigger: 'change' }],
        basicFare: [{ required: true, message: '请输入基础车费（元）', trigger: 'blur' },
          {
            pattern: /^(([1-9]{1}\d{0,9})|(0{1}))(\.\d{1,2})?$/,
            message: "请输入合法的金额数字，最多两位小数",
            trigger: "change"
          }
        ],
        standardTime: [
          {required: true, message: '请输入标准时长（分钟）', trigger: 'blur'},
          { validator: checkInt, trigger: 'change' }
        ],
        timeoutStandard: [{required: true, message: '请输入超时标准（元/小时）', trigger: 'blur'},
          {
            pattern: /^(([1-9]{1}\d{0,9})|(0{1}))(\.\d{1,2})?$/,
            message: "请输入合法的金额数字，最多两位小数",
            trigger: "change"
          }
        ],
        realOilPrices: [{required: true, message: '请输入现实油价（元/L）', trigger: 'blur'},
          {
            pattern: /^(([1-9]{1}\d{0,9})|(0{1}))(\.\d{1,2})?$/,
            message: "请输入合法的金额数字，最多两位小数",
            trigger: "change"
          }
        ],
        standardTimeXia: [{required: true, message: '请输入油费标准-夏季（6.1~9.30）', trigger: 'blur'},
          {
            pattern: /^(([1-9]{1}\d{0,9})|(0{1}))(\.\d{1,2})?$/,
            message: "请输入合法的金额数字，最多两位小数",
            trigger: "change"
          }
        ],
        standardTimeNoxia: [{required: true, message: '请输入油费标准-非夏季', trigger: 'blur'},
          {
            pattern: /^(([1-9]{1}\d{0,9})|(0{1}))(\.\d{1,2})?$/,
            message: "请输入合法的金额数字，最多两位小数",
            trigger: "change"
          }
        ],
        taxRate: [{required: true, message: '请输入税率', trigger: 'blur'},
          {
            pattern: /^(([1-9]{1}\d{0,9})|(0{1}))(\.\d{1,2})?$/,
            message: "请输入合法的税率，最多两位小数",
            trigger: "change"
          }
        ],
        serviceRate: [{required: true, message: '请输入服务费率', trigger: 'blur'},
          {
            pattern: /^(([1-9]{1}\d{0,9})|(0{1}))(\.\d{1,2})?$/,
            message: "请输入合法的服务费率，最多两位小数",
            trigger: "change"
          }
        ],
      },
      cityOptions: citys
    }
  },
  mounted() {
  },
  methods: {
    init(id) {
      this.visible = true
      if(id){
        this.$set(this.rowInfo,'id',id);
        this.loading = true;
        qryCostInfoSet(id).then(res => {
          this.loading = false;
          this.rowInfo = res.data.data
        })
      }
      loadProjectList().then(res => {
        this.projectOptions = res.data.data
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
            let submitRowInfo = JSON.parse(JSON.stringify(this.rowInfo))
            let cityCodes = this.rowInfo.cityCode;
            if(Object.prototype.toString.call(cityCodes)=='[object Array]'){
              let cityNames = [];
              for(let i=0;i<cityCodes.length;i++){
                let obj = {};
                obj = this.cityOptions.find(item => {
                  return item.codeItemId === cityCodes[i] //筛选出匹配数据
                })
                cityNames.push(obj.codeName);
              }
              this.rowInfo.cityName = cityNames.join(",");
              submitRowInfo.cityName = cityNames.join(",");
              submitRowInfo.cityCode = cityCodes.join(",");
            }else{
              let obj = {};
              obj = this.cityOptions.find(item => {
                return item.codeItemId === cityCodes //筛选出匹配数据
              })
              this.rowInfo.cityName = obj.codeName;
              submitRowInfo.cityName = obj.codeName;
            }
            updCostInfoSet(submitRowInfo).then((res) => {
              if(res.data.code==0){
                // 在store中改变修改的值
                this.$message.success("操作成功")
                // 子组件中触发父组件的初始化方法
                this.$emit('refresh', '')
                // 关闭弹框
                this.closeForm()
              }
            })
        } else {
          return false
        }
      })
    },
    closeForm() {
      this.visible = false
      // 重置表单
      this.$refs['rowInfo'].resetFields()
      this.rowInfo = {
        id:'',
        basicFare:'',
        standardTime:'',
        timeoutStandard:'',
        realOilPrices:'',
        standardTimeXia:'',
        standardTimeNoxia:'',
        taxRate:13,
        serviceRate:10,
        cityCode: '',
        cityName: ''
      }
    }
  }
}
</script>
<style scoped  rel="stylesheet/scss">
  .sideBarForm{
    overflow: auto;
    height: calc(100vh - 80px);
    margin-top: 40px;
  }
  .fullScreen .formHead,.fullScreen .formButton{
    right: 0;
  }
  .formHead{
    position: fixed;
    right:-420px;
    top:0;
    background-color: #27c3dc;
    height: 40px;
    width: 420px;
    display: flex;
    transition: all 0.5s;
    z-index:1100;
  }
  .formBack{
    width: 40px;
    text-align: center;
    height: 100%;
    background-color: #ffbf00;
    font-size: 16px;
    color:#ffffff;
    line-height: 40px;
    cursor: pointer;
  }
  .listName{
    color:#ffffff;
    font-size: 16px;
    line-height: 40px;
    padding-left: 20px;
  }
  .formContent{
    padding: 20px;
  }
  .formButton{
    position: fixed;
    right:-420px;
    bottom:0;
    background-color: #ffffff;
    height: 40px;
    width: 420px;
    display: flex;
    transition: all 0.5s;
    z-index:1100;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .avatar-uploader .el-upload{
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    font-size: 28px;
    color: #8c939d;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
  }
  .avatar {
    width: 50px;
    height: 50px;
    display: block;
  }
</style>
